import { useCallback } from "react";
import apiClient2 from "../../api/apiClient2";
import apiPaths from "../../api/endpoints";

/**
 * Mirrors srcMobile/Screens/FunBoxScreen/ChatBoxScreen/useRetrieveContent.tsx
 *
 *  getRetrieveContent(apiURL)  → GET  any retrieve endpoint
 *  postRetrieveContent(data)   → POST /v3/captureContentResponse  (multipart)
 */
export function useRetrieveContent() {
  const getRetrieveContent = useCallback(async (apiURL: string) => {
    try {
      const response = await apiClient2.get(apiURL, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response?.data;
    } catch (err: any) {
      console.error("getRetrieveContent error:", err);
      return null;
    }
  }, []);

  const postRetrieveContent = useCallback(async (data: FormData) => {
    try {
      const response = await apiClient2.post(
        apiPaths.CAPTURE_CONTENT_RESPONSE,
        data,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      return response.data;
    } catch (err: any) {
      console.error("postRetrieveContent error:", err);
      return null;
    }
  }, []);

  return { getRetrieveContent, postRetrieveContent };
}
